import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import type { ShipmentMapData } from "shared-ui/src/features/maps-feature/ShipmentMapProvider";
import { getShipmentMap } from "../stores/mapsStore";

const CACHE_KEY_SHIPMENT_MAP = "ShipmentMap";

interface UseGetShipmentMapParams {
  biOrderId?: string | number | null;
  trackingNumber?: string | null;
  lastSeenLocation?: string | null;
  width?: number;
  height?: number;
}

export const useGetShipmentMap = ({
  biOrderId,
  trackingNumber,
  lastSeenLocation,
  width,
  height,
}: UseGetShipmentMapParams) => {
  const hasIdentifiers =
    biOrderId !== null &&
    biOrderId !== undefined &&
    biOrderId !== "" &&
    trackingNumber !== null &&
    trackingNumber !== undefined &&
    trackingNumber !== "";

  return useQuery<ShipmentMapData, Error>({
    queryKey: [CACHE_KEY_SHIPMENT_MAP, biOrderId, trackingNumber, lastSeenLocation, width, height],
    queryFn: () =>
      getShipmentMap({
        biOrderId: biOrderId as string | number,
        trackingNumber: trackingNumber as string,
        lastSeenLocation: lastSeenLocation as string | null,
        width,
        height,
      }),
    enabled: hasIdentifiers,
    staleTime: ms("0s"),
  });
};
